<template>
	<div class="header flex">
		<div class="logo" @click="homeIndex"><img src="../../assets/logo.png" /></div>
		<template v-if="$slots.default">
			<slot></slot>
		</template>
		<template v-else>
			<el-col :span="12">
				<div class="search" @keyup.enter="search">
					<el-input placeholder="请输入搜索关键词" v-model="search_keyword" class="input-with-select">
						<el-button slot="append" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</el-input>
				</div>
			</el-col>
			<div class="qrcode"><img src="../../assets/qrcode.jpg" /></div>
		</template>
	</div>
</template>
<script>
	export default{
		name:'commonHeader',
		data(){
			return {
				search_keyword:''
			}
		},
		props:{
			keyword:{
				type:String,
				default:''
			}
		},
		watch:{
			keyword(){
				this.search_keyword = this.keyword
			}
		},
		mounted(){
			
		},
		methods:{
			search() {
				this.$router.push({'path':'/goods',query:{'search':this.search_keyword}});
			},
		}
		
	}
</script>
<style>
	
</style>
